import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import { authRoutes } from "../../features/auth/config/authRoutes";
import { resolvePostAuthRoute } from "../../features/auth/utils/resolvePostAuthRoute";
import RouteFallback from "./fallback/RouteFallback";

export default function RootRedirect() {
  const { isAuthenticated, status, user } = useAuth();

  if (status === "booting") return <RouteFallback />;

  return isAuthenticated
    ? <Navigate to={resolvePostAuthRoute(user)} replace />
    : <Navigate to={authRoutes.login} replace />;
}
